import { render, staticRenderFns } from "./InitialBellRightPanel.vue?vue&type=template&id=5141fe6a&scoped=true&"
import script from "./InitialBellRightPanel.vue?vue&type=script&lang=js&"
export * from "./InitialBellRightPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5141fe6a",
  null
  
)

export default component.exports